import { GlobalLoader } from '../_loaders/globalLoader';
import { NestedLoader } from '../_loaders/nestedLoader';
import { TrackingLoader } from '../_loaders/trackingLoader';

const globalLoader = new GlobalLoader();
const nestedLoader = new NestedLoader();
const trackingLoader = new TrackingLoader();

